import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Whatnde() {
  return (
    <section className="what_nde p-100 text_nde">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>What did we do?</h2>
            <p>
              We conducted detailed code analysis, reviewed the backend code and
              logic through the smoke testing and regression testing, and
              finally, edited the outdated code to increase efficiency and
              enhance the overall speed.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="what_nde_img">
              <StaticImage
                src="../../../images/case-studies/nde/what_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={540}
                height={611}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whatnde;
